import '../styles/index.scss';
import { docReady } from './helpers/docReady';
import { marqueeSection } from './sections/marquee';
import { headerUserScrolling } from './sections/header';
docReady(() => {
    marqueeSection();
    headerUserScrolling();
});
